<template>
  <div>
    <Menu 
      @tourChanged="changeTourSource($event)" 
      :mdList="mdList"
    />
    <TourFrame :link="linkStr" />
  </div>
</template>

<script>
import Menu from '@/components/Menu.vue'
import TourFrame from '@/components/TourFrame.vue'

export default {
  data: () => ({
    linkStr: "https://kuula.co/share/collection/7PX3t?fs=1&vr=1&thumbs=-1&info=0&logo=-1",
    mdList: [
      {
        url: 'collection/7PZfn?fs=1&vr=1&thumbs=-1&info=0&logo=-1',
        source: 10,
        name: 'CÁMBULO 59M2 | KIT MODERNO',
        style: {
          bg: 'orange-1',
          color: 'menu-item-text'
        }
      },
      {
        url: 'collection/7PX3t?fs=1&vr=1&thumbs=-1&info=0&logo=-1',
        source: 11,
        name: 'CÁMBULO 59M2 | KIT CAMPESTRE',
        style: {
          bg: 'orange-1',
          color: 'menu-item-text'
        }
      },
      {
        url: 'collection/7PZfd?fs=1&vr=1&thumbs=-1&info=0&logo=-1',
        source: 12,
        name: 'CÁMBULO 69M2 | KIT MODERNO',
        style: {
          bg: 'orange-1',
          color: 'menu-item-text'
        }
      },
      {
        url: 'collection/7PXR4?fs=1&vr=1&thumbs=-1&info=0&logo=-1',
        source: 1,
        name: 'CÁMBULO 69M2 | KIT CAMPESTRE',
        style: {
          bg: 'orange-1',
          color: 'menu-item-text'
        }
      },
      {
        url: 'collection/7P19f?fs=1&vr=1&thumbs=-1&info=0&logo=-1',
        source: 2,
        name: 'CÁMBULO 75M2 | KIT MODERNO',
        style: {
          bg: 'orange-1',
          color: 'menu-item-text'
        }
      },
      {
        url: 'collection/7P1vH?fs=1&vr=1&thumbs=-1&info=0&logo=-1',
        source: 3,
        name: 'CÁMBULO 75M2 | KIT CAMPESTRE',
        style: {
          bg: 'orange-1',
          color: 'menu-item-text'
        }
      }
    ]
  }),
  components: {
    Menu,
    TourFrame
  },
  methods: {
    changeTourSource(newSource) {
      this.linkStr = newSource;
    }
  }
}
</script>